import { createLayer } from "@/api/hooks/layer";
import { useProfileAndTabParams } from "@/hooks";
import type { LayerCreateControllerProp } from "@/overlay/components/SmartForm/LayerForms/LayerFormMapping";
import { useAppDispatch } from "@/reducer";
import type { WindAnimationLayerCreate } from "@mm/metx-workbench.meteomatics.com";
import _ from "lodash";
import type { SubmitHandler } from "react-hook-form";
import { type WindAnimationFormData, WindAnimationLayerForm } from "../view/WindAnimationLayerForm";

/**
 * Handles all the logic for wind animation creation.
 * Note:
 * This is a controller, meaning that we should generally NOT delegate layer creation logic
 * to the parent component by passing callback from parent etc.
 */
export function WindAnimationCreateController(props: LayerCreateControllerProp<WindAnimationLayerCreate>) {
  const { selectedMapId, defaultPayload, onDone } = props;
  const dispatch = useAppDispatch();
  const { profileId } = useProfileAndTabParams();

  const onSubmit: SubmitHandler<WindAnimationFormData> = (formData) => {
    if (!profileId) {
      return;
    }
    const finalPayload = _.merge(defaultPayload, formData.layerData);
    dispatch(createLayer({ mapId: selectedMapId, profileId: profileId, data: finalPayload }));

    onDone?.();
  };

  return (
    <WindAnimationLayerForm
      defaultFormData={defaultPayload}
      onSubmit={onSubmit}
      submitMode="onSubmit"
      onCancel={props.onDone}
    />
  );
}
